import React from "react";
import styled from "styled-components";

const BlockStyle = styled.div`
    left: 0;
    right: 0;
    top: -40px;
    height: 40px;
    margin: -40px -40px 0 -40px;
    position: sticky;
    background-color: ${props => props.theme.greyLightest};
`;

const TableStyle = styled.table`
    width: 100%;
    border-collapse: separate;
    color: ${props => props.theme.black};

    >thead tr th, >thead tr td {
        top: 0;
        position: sticky;
        border-top: 1px solid ${props => props.theme.greyLight};
        background-color: ${props => props.theme.greyLightest};
        border-right: 1px solid ${props => props.theme.greyLight};
    }
    tr {
        th, td {
            font-size: 12px;
            overflow: hidden;
            padding: 12px 6px;
            vertical-align: top;
            white-space: nowrap;
            text-overflow: ellipsis;
            border-bottom: 1px solid ${props => props.theme.greyLight};
            background-color: ${props => props.theme.white};
            &:first-child {
                border-left: 1px solid ${props => props.theme.greyLight};
            }
            &:last-child {
                border-right: 1px solid ${props => props.theme.greyLight};
            }
        }
        &.selected td {
            color: ${props => props.theme.white};
            background-color: ${props => props.theme.primaryLight};
        }
    }
`;

export const Table = ({ children }) =>
    <>
        <BlockStyle />
        <TableStyle>
            {children}
        </TableStyle>
    </>;